import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { LinkTarget as s } from "../../types/target-link-types.js";
import { RocheUIHeadline as l } from "../headline/roche-headline.js";
import { RocheUITextLink as d } from "../text-link/roche-text-link.js";
import r from "./roche-back-to-branch.module.scss.js";
const v = ({
  overlineText: o,
  headline: t,
  linkText: c,
  linkVisuallyHiddenText: i,
  link: n,
  icon: a,
  slot: h
}) => /* @__PURE__ */ m("section", { className: r["roche-back-to-branch"], slot: h, children: [
  /* @__PURE__ */ e("div", { className: r["roche-back-to-branch__content"], children: /* @__PURE__ */ e(l, { overline: o, headline: t, level: "5" }) }),
  /* @__PURE__ */ e(
    d,
    {
      rightIcon: a,
      href: n,
      text: c,
      visuallyHiddenText: i,
      target: s.SELF
    }
  )
] });
export {
  v as RocheUIBackToBranch
};
